module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "user-bar",
    attrs: {
      "to": {
        name: _vm.currentLink
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.currentUser.name) ? [_c('img', {
    attrs: {
      "src": require("../assets/avatar.png"),
      "alt": "avatar"
    }
  })] : [_c('img', {
    attrs: {
      "src": require("../assets/user_normal.jpg"),
      "alt": "未登陆"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "holder"
  }, [_vm._v(_vm._s(_vm.holder))]), _vm._v(" "), _c('div', {
    staticClass: "icon icon-camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon icon-pen"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd43b34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserBar.vue
// module id = 187
// module chunks = 0